import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { FlexLayout } from '@calendly/ui/components/flex-layout';
import { AiCalendarIcon, CopyIcon, EditIcon, FlagIcon } from '@calendly/ui/components/icons';
import { BodyText, TitleText } from '@calendly/ui/components/typography';
import { colorAccentGreenMedium, colorAccentOrangeMedium, colorAccentRedMedium } from '@calendly/ui/theme';
import { ClipboardButton } from 'features/one_off_share_modal';
import { stripHtmlTags } from 'features/scoped_url_state';
const promptUnderlineCss = "p1yxek8f";
const CalliePromptUnderline = ({
  children
}) => <span className={promptUnderlineCss}>{children}</span>;
const sectionCss = "s1nj1305";
const headingCss = "hwz57zr";
const gridCss = "gndmuw0";
const promptCardCss = "py6smb2";
const promptCardHeadCss = "p7iaym1";
const promptCss = "p1sqh1uy";
const calliePromptHtmlComponents = {
  CalliePromptUnderline
};
const promptsFrom = (idPrefix, definitions) => definitions.map(({
  text
}, index) => ({
  promptId: `${idPrefix}-${index + 1}`,
  content: HtmlParser(text, calliePromptHtmlComponents),
  copySource: text
}));
const Prompt = ({
  children,
  copySource,
  isCallieEnabled
}) => <div className={promptCss}>
    <BodyText as="p" size="small">
      {children}
    </BodyText>
    {isCallieEnabled && <ClipboardButton aria-label={I18n.t('publisher.home.scheduling_subsection.callie.copy_prompt_aria')} content={stripHtmlTags(copySource)} decoration="ghost" fontWeight="normal" size="small" successStyle="success">
        <CopyIcon />
      </ClipboardButton>}
  </div>;
const CalliePromptCard = ({
  icon: IconComponent,
  iconColor,
  prompts,
  subtitle,
  testId,
  title,
  isCallieEnabled
}) => <div className={promptCardCss} data-testid={testId}>
    <div className={promptCardHeadCss}>
      <IconComponent color={iconColor} aria-hidden />
      <div>
        <TitleText level="4" size="medium">
          {title}
        </TitleText>
        <BodyText size="small" color="muted">
          {subtitle}
        </BodyText>
      </div>
    </div>
    {prompts.map(({
    content,
    copySource,
    promptId
  }) => <Prompt key={promptId} copySource={copySource} isCallieEnabled={isCallieEnabled}>
        {content}
      </Prompt>)}
  </div>;
export const CallieSamplePrompts = ({
  isCallieEnabled
}) => {
  const shareAvailabilityPrompts = promptsFrom('share-availability', [{
    text: I18n.t('publisher.home.scheduling_subsection.callie.prompts.share_availability.prompt_1')
  }, {
    text: I18n.t('publisher.home.scheduling_subsection.callie.prompts.share_availability.prompt_2')
  }, {
    text: I18n.t('publisher.home.scheduling_subsection.callie.prompts.share_availability.prompt_3')
  }]);
  const bookTimePrompts = promptsFrom('book-time', [{
    text: I18n.t('publisher.home.scheduling_subsection.callie.prompts.book_time.prompt_1')
  }, {
    text: I18n.t('publisher.home.scheduling_subsection.callie.prompts.book_time.prompt_2')
  }, {
    text: I18n.t('publisher.home.scheduling_subsection.callie.prompts.book_time.prompt_3')
  }]);
  const overrideDefaultsPrompts = promptsFrom('override-defaults', [{
    text: I18n.t('publisher.home.scheduling_subsection.callie.prompts.override_defaults.prompt_1')
  }, {
    text: I18n.t('publisher.home.scheduling_subsection.callie.prompts.override_defaults.prompt_2')
  }, {
    text: I18n.t('publisher.home.scheduling_subsection.callie.prompts.override_defaults.prompt_3')
  }]);
  return <FlexLayout direction="column" gap="16" className={sectionCss} data-testid="callie-sample-prompts">
      <TitleText className={headingCss} level="3" size="medium">
        {I18n.t('publisher.home.scheduling_subsection.callie.prompts.heading')}
      </TitleText>
      <div className={gridCss}>
        <CalliePromptCard icon={AiCalendarIcon} iconColor={colorAccentGreenMedium} prompts={shareAvailabilityPrompts} subtitle={I18n.t('publisher.home.scheduling_subsection.callie.prompts.share_availability.subtitle')} testId="callie-prompt-card-share_availability" title={I18n.t('publisher.home.scheduling_subsection.callie.prompts.share_availability.title')} isCallieEnabled={isCallieEnabled} />
        <CalliePromptCard icon={FlagIcon} iconColor={colorAccentRedMedium} prompts={bookTimePrompts} subtitle={I18n.t('publisher.home.scheduling_subsection.callie.prompts.book_time.subtitle')} testId="callie-prompt-card-book_time" title={I18n.t('publisher.home.scheduling_subsection.callie.prompts.book_time.title')} isCallieEnabled={isCallieEnabled} />
        <CalliePromptCard icon={EditIcon} iconColor={colorAccentOrangeMedium} prompts={overrideDefaultsPrompts} subtitle={I18n.t('publisher.home.scheduling_subsection.callie.prompts.override_defaults.subtitle')} testId="callie-prompt-card-override_defaults" title={I18n.t('publisher.home.scheduling_subsection.callie.prompts.override_defaults.title')} isCallieEnabled={isCallieEnabled} />
      </div>
    </FlexLayout>;
};

require("./callie_sample_prompts.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./callie_sample_prompts.js");